import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form'

import appReducer from './app/appReducer';
import bannerReducer from './banner/bannerReducer';
import companyReducer from './company/companyReducer';
import giveawayReducer from './giveaway/giveawayReducer';
import orderReducer from './order/orderReducer';
import paymentReducer from './payment/paymentReducer';
import productReducer from'./product/productReducer';
import promocodeReducer from './promocode/promocodeReducer';
import rewardReducer from './reward/rewardReducer';
import userReducer from './user/userReducer';

export default combineReducers({
  app: appReducer,
  banner: bannerReducer,
  company: companyReducer,
  giveaway: giveawayReducer,
  form: formReducer,
  order: orderReducer,
  payment: paymentReducer,
  product: productReducer,
  promocode: promocodeReducer,
  reward: rewardReducer,
  user: userReducer
});



/** WEBPACK FOOTER **
 ** ./src/redux/reducers.js
 **/